import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { CHANNELS } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import ListingChipsList from '@spotahome/ui-library/src/tenant/components/ListingChipsList';

import './ListingValuePropositionModal.scss';

const openListingValuePropositionModal = ({
  chipList = [],
  fullscreenOnMobile = false
} = {}) => {
  const propertyChips = chipList.filter(chip => !chip.isGuarantee);
  const guaranteeChips = chipList.filter(chip => chip.isGuarantee);

  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('listing.value.proposition.title'),
    body: (
      <>
        {propertyChips.length > 0 && (
          <div className="listing-value-proposition-modal__section listing-value-proposition-modal__section-chips-list">
            <ListingTitle role="tertiary">
              {trans('value.proposition.features.title')}
            </ListingTitle>
            <ListingChipsList chipList={propertyChips} />
          </div>
        )}
        {guaranteeChips.length > 0 && (
          <div className="listing-value-proposition-modal__section listing-value-proposition-modal__section-chips-list">
            <ListingTitle role="tertiary">
              {trans('value.proposition.features.title.always')}
            </ListingTitle>
            <ListingChipsList chipList={guaranteeChips} />
          </div>
        )}
      </>
    ),
    fullscreenOnMobile
  });
};

export default openListingValuePropositionModal;
